import React, { Component } from 'react';
import _ from 'lodash';

import Header from '../../../components/Common/Header/Header';
import Dashboard from '../../../container/Admin/Dashboard/Dashboard';
import Footer from '../../../components/Admin/Footer/Footer';
import Sidebar from '../../../components/UI/Sidebar/Sidebar';
import RecruiterManagement from '../../../container/Admin/RecruiterManagement/RecruiterManagement';
import ClientManagement from '../../../container/Admin/ClientManagement/ClientManagement';
import DashboardBar from '../../../container/Admin/DashboardBar/DashboardBar';
import './AdminLayout.css';

import {
  Route,Router,Switch
} from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';


const history = createHistory();

/**
* @desc Layout for recruiter
* @version 
* @author Lakshmikanth 
*/
class AdminLayout extends Component {

  render() {
    return (
      <div className="root adminLayout">
        <div className="app-container adminLayout">
          <Header/>
          <div className="admin-dashboard">
            <div className="admin-navigation">
              <Sidebar expanded={false}/> 
              <div className="app-body">
                <DashboardBar activeLink='recruiters'/> 
                <PropsRoute exact path="/admin/dashboard" component={RecruiterManagement} />
                <PropsRoute exact path="/admin/recruiter" component={RecruiterManagement} />
                <PropsRoute exact path="/admin/client" component={ClientManagement} /> 
              </div>       
            </div>
          </div>
          <div className="simpleLayoutFooter">
            <Footer/>
          </div>
        </div>
      </div>
    );
  }
}
/**
* @desc merging props
* @param component ,rest
* @return component,finalprops
*/
const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return (
    React.createElement(component, finalProps)
  );
}
/**
* @desc adding props to router
* @param component ,rest
* @return merged props,component
*/
const PropsRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest} render={routeProps => {
      return renderMergedProps(component, routeProps, rest);
    }}/>
  );
}

export default AdminLayout;



// WEBPACK FOOTER //
// ./src/hoc/layout/Admin/AdminLayout.js